/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {AdnSelectModule} from '../../common/directives/adn-select/adn-select.module';
import {AdminListModule} from '../../common/directives/admin-list.module';
import {FormControlsModule} from '../../common/directives/form-controls/form-controls.module';
import {CouponValidityComponent} from './coupon-validity-component';
import {CouponStatusComponent} from './coupon-status-component';
import {CouponCopyModalComponent} from './coupon-copy-modal.component';
import {CouponEditPageComponent} from './coupon-edit-page.component';
import {CouponListPageComponent} from './coupon-list-page.component';
import {CouponRoutePageComponent} from './coupon-route-page.component';

const COUPON = [
  CouponValidityComponent,
  CouponStatusComponent,
  CouponCopyModalComponent,
  CouponEditPageComponent,
  CouponListPageComponent,
  CouponRoutePageComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    AdnSelectModule,
    AdminListModule,
    FormControlsModule
  ],
  declarations: COUPON,
  exports: COUPON
})
export class CouponModule {
}
